import styled from 'styled-components';

export default styled.div`
  margin: 0;
  padding-bottom: 1rem;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    padding-bottom: 0rem;
    padding-right: 1rem;
  }

  p {
    margin: 0;
    font-weight: 600;
    font-family: ${({ theme }) => theme.standoutFontFamily};
    font-size: 1rem;
    color: white;
    line-height: 175%;
  }

  strong {
    font-size: 1.75rem;
    vertical-align: middle;
  }
`;
